import type { UserStatus } from '../../constants/Constants';
import type { sizeOfPortfolio } from '../../features/Registration/constants/UnitOptions';
import type { Permission } from './Permission';

export type UserResponse = {
  statusCode: number;
  data: {
    user: User;
  };
};

export enum LLTypes {
  SMB = 'SMB',
  Institutional = 'Institutional',
}

export type Company = {
  hubspot_parent_company_id: string;
  is_active: boolean;
  operator_company_id: string;
  operator_company_marketing_name: string;
};

export interface AxiosUserResponse {
  data: UserResponse;
}

export type User = {
  email: string;
  lastName?: string;
  firstName?: string;
  fullName?: string;
  id?: string;
  phone?: string;
  ownedUnits?: number;
  status?: UserStatus;
  propertyLLC?: string;
  hdyhearAboutUs?: string;
  partner?: string;
  role: string;
  sizeOfPortfolio: sizeOfPortfolio;
  isAccountAdmin: boolean;
  setPasswordLink?: string;
  isSMB?: boolean;
  /** Remove when OTTERS_4648_USE_GO_LLP_BE_REGISTER_ENDPOINT is cleaned up */
  LLType?: LLTypes;
  landlordPortalExperience?: LLTypes;
  canEnrollProperties?: boolean;
  hasUniversalPropertyAccess?: boolean;
  /** Remove when OTTERS_4648_USE_GO_LLP_BE_REGISTER_ENDPOINT is cleaned up */
  foundAln?: {
    source: string;
    companyId: string;
    numberOfProperties: number;
    companyName: string;
  };
  foundCompanyDirectory?: {
    source: string;
    companyId: string;
    numberOfProperties: number;
    companyName: string;
  };
  company?: Company;
  userPermissions: Permission[];
  newDealsDashboardAccess: boolean;
  claimsReportAccess: boolean;
};
